import { Component, ViewChild, ElementRef } from "@angular/core"
import { trigger, transition, animate, style } from "@angular/animations"
import { AppService } from '../../../app.service';
import { MatDialog } from '@angular/material/dialog'; import { ImplementStatusModalComponent } from '../implement-status-modal/implement-status-modal.component';
import { AttachImplementModalComponent } from '../attach-implement-modal/attach-implement-modal.component';
import { RemoveImplementModalComponent } from '../remove-implement-modal/remove-implement-modal.component';
import { RecordRepairModalComponent } from '../record-repair-modal/record-repair-modal.component';
import { RecordReplaceModalComponent } from '../record-replace-modal/record-replace-modal.component';
import { ChangeImplementJobsiteModalComponent } from '../change-implement-jobsite-modal/change-implement-jobsite-modal.component';
import { ImplementDetails, EquipmentDetails, InspectionDetails, ComponentDetails, ImplementHistory } from './implement-details';
import { ImplementDetailsService } from './implement-details.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OrdinalDateParse } from '../adapters/ordinal-date-adapter';
import { Http } from '@angular/http';
import { SchematicViewComponent } from '../schematic-view/schematic-view.component';
import { SetupImplementService } from "../setup-implement/setup-implement.service";
import { CrackStatusVM, GenericIdName } from "../setup-implement/setup-implement.model";
import { EquipmentDetailsParams } from "../setup-equipment/setup-equipment.model";
import { DomSanitizer } from "@angular/platform-browser";
import { ImplementForEquipmentDetails, InspectionHistoryDetails, ImplementHistoryVM, SchematicAndObservationPointDetails, ImplementSummaryForEquipmentDetails } from "../equipment-details/equipment-details.model";
import { GETUpdateMeterComponent } from "../equipment-details/components/update-meter/get-update-meter.component";
import { GETChangeJobsiteComponent } from "../equipment-details/components/change-jobsite/change-jobsite.component";
import { ImplementActionComponent } from "../equipment-details/components/implement-action/implement-action.component";
import { PerformInspectionComponent } from "../equipment-details/components/perform-inspection/perform-inspection.component";
import { ImplementRebuildDialogComponent } from "../equipment-details/components/implement-rebuild-dialog/implement-rebuild-dialog.component";
import { ImplementRebuildCompleteDialogComponent } from "../equipment-details/components/implement-rebuild-complete-dialog/implement-rebuild-complete-dialog.component";
import { ImplementTargetsUpdateComponent } from "../equipment-details/components/implement-targets-update/implement-targets-update.component";
import { ImplementCycleDetails } from "../add-observation-point/add-observation-point-modal";
import { EquipmentDetailsService } from "../equipment-details/equipment-details.service";
import { UserService } from "../../../../app/shared/services/user.service";
import { DocumentLibraryComponent } from "../equipment-details/components/document-library/document-library.component";
import { ProductImprovementImplementDialogComponent } from "../../ProductImprovement/product-improvement-implement-dialog/product-improvement-implement-dialog.component";
import { InspectionAttachedDocsComponent } from "../inspection-attached-docs/inspection-attached-docs.component";
import { WarrantyStatusDialogComponent } from "../../warranty-type-setup/warranty-status-dialog/warranty-status-dialog.component";
import { DocumentLibraryService } from "../services/document-library.service";
import { PreferencesService } from "../../preferences/preferences.service";
import { EnablePreferenceTasksVM } from "../../preferences/models/preferences.model";
import { InspectionPlannerComponent } from "../../manage-equipment/components/inspection-planner/inspection-planner.component";
import { DataIdName } from "../entities/global/model";
import { GETInventoryService } from "../services/inventory.service";
import { NotificationsService } from "angular2-notifications";
import { NewInspectionService } from "../inspections/inpsection.service";
import { GETPreferencesService } from "../preferences/preferences.service";

@Component({
  selector: "implement-details",
  templateUrl: './implement-details.component.html',
  styleUrls: ['./implement-details.component.scss'],
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(25%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('500ms', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ]
    )]
})
export class ImplementDetailsComponent {
  @ViewChild('btnStatusChange') statusChange: ElementRef;
  //pageTitle: string;// = "BKT0001 Details (Excavator Bucket)";
  //pageSubTitle: string = "Record and view data about this implement here. "; // Will need to make this dynamic

  implement: ImplementDetails = new ImplementDetails();
  equipment: EquipmentDetails = new EquipmentDetails();
  inspections: InspectionDetails[] = [];
  getComponents: ComponentDetails[] = [];
  implementHistory: ImplementHistory[] = [];

  // Toggles to show or hide different components.
  showImplement: boolean = false;
  showEquipment: boolean = false;
  showInspections: boolean = false;
  showComponents: boolean = false;
  showHistory: boolean = false;
  showChangeJobsiteModal: boolean = false;
  showRemoveImplementModal: boolean = false;
  showAttachImplementModal: boolean = false;
  showImplementStatusModal: boolean = false;
  showRepairOrReplaceModal: boolean = false;

  ImplementId: number;

  implementStatusText: string = "";
  implementStatusDesc: string = "";

  currency_symbol: string = "$";
  unit_life: string = "hrs";

  // Define eval colour thresholds.
  THRESHOLD_EVAL_A: number = 30;
  THRESHOLD_EVAL_B_MAX: number = 60;
  THRESHOLD_EVAL_B_MIN: number = 30;
  THRESHOLD_EVAL_C_MAX: number = 80;
  THRESHOLD_EVAL_C_MIN: number = 60;

  dateParser: OrdinalDateParse = new OrdinalDateParse();

  GETUri: string = "";

  wearStyleId: number;
  makeList: GenericIdName[] = [];
  loading: boolean = false
  equipmentDetails: EquipmentDetailsParams;
  CustomerId: number;
  inspectionDetails: InspectionHistoryDetails[];
  ImplementForEquipmentDetails: ImplementForEquipmentDetails[] = [];
  ImplementDetails: ImplementForEquipmentDetails[] = [];
  AssetDetailsHistroy: ImplementForEquipmentDetails;
  SchematicAndObservationPoints: SchematicAndObservationPointDetails[];
  ImplementSummaryForEquipmentDetails: ImplementSummaryForEquipmentDetails;
  //appUris: AppUris;
  isJobRoleDefault: boolean = true;

  //warranty status
  startSmu: number = 0
  ResidualWarrantyHours: number = 0
  WarrantyTypeIntialHours: number = 0
  isGreen: boolean = false
  isGray: boolean = true
  isRed: boolean = false
  isOrange: boolean = false
  statusList: DataIdName[];

  selectedTab
  ltd: number
  isInspector: boolean = false;
  displayCritical: boolean = true;
  displayNonCritical: boolean = true;
  displayGET: boolean = true;

  showOPType: boolean = true;
  showImageHx: boolean = true;
  showWorn: boolean = true;
  showCrackLength: boolean = true;
  showCurrentMeasure: boolean = true;
  showCrackSeverity: boolean = true;
  showStartingDim: boolean = true;
  showUsedLimit: boolean = true;
  showBudgetLife: boolean = true;
  showLife: boolean = true;
  showResidualLife100: boolean = true;
  showResidualLife120: boolean = true;
  showLifeTotalProjected: boolean = true;
  showInstallDate: boolean = true;
  showPartNo: boolean = true;
  showManufacturer: boolean = true;
  showAllCosts: boolean = true;
  showBar: boolean;
  crackSeverityList: boolean;

  isAdministrator: boolean = false;
  currentClickedId: number;
  editableMaintenanceCost: boolean = true;
  editableCapitalCost: boolean = true;
  editableBCM: boolean = true;
  editableTons: boolean = true;
  updateCost: boolean = false;
  crackOptions: CrackStatusVM[] = [];
  activeCrackStatusIds: number[] = [];
  showLocationName: boolean = true;
  constructor(private route: ActivatedRoute, private _appService: AppService, public changeStatusModal: MatDialog,
    public attachImplementModal: MatDialog, public removeImplementModal: MatDialog,
    private _moduleService: ImplementDetailsService, public recordRepairModal: MatDialog, public recordReplaceModal: MatDialog,
    public changeImplementJobsiteModal: MatDialog, private http: Http, public schematicViewComponent: MatDialog,
    private _implementService: SetupImplementService, private _router: Router, private _user: UserService,
    private _sanitizer: DomSanitizer, private _equipmentDetailsService: EquipmentDetailsService,
    private _DocLibraryservice: DocumentLibraryService,
    private readonly _pref: PreferencesService, public _inventoryService: GETInventoryService, private _notify: NotificationsService,
    private _inspectionService: NewInspectionService
  ) { }

  ngOnInit() {
    this._appService.setPageTitle('Implement Details');
    // this._appService.setPageSubTitle('');

    this.GetPreferenceTaskList();

    // this._appService.returnBrandedGETHost().subscribe(result => {
    //     this.GETUri = result;
    // });

    this.route.params.subscribe(params => {
      this.ImplementId = +params['implementId'];

      if (this.ImplementId) {
        this.initialise();
      }
    });
    //this._appService.getAppUris().subscribe(result => { this.appUris = result; });

    this.selectedTab = this.route.snapshot.params.selectedTab;

    this._inventoryService.returnInventoryStatusList().subscribe(response => {
      this.statusList = response;
      this.statusList = this.statusList.filter(x => x.Id != 6)
    }, error => { console.log(error); });
  }

  initialise() {
    this.loadEquipmentDetails();
    
    this.LoadJobRoles();
    this.loadAssetDetails();
    this.loadMakes();
    this.reloadDetails();
    //this.loadImplementDetails();
    //this.loadImplementDetailsHistroy();
    this.loadEquipmentInspectionDetails();
    //this.loadImplementHistoryDetails();
    this.loadCycleDetails();
    //this.checkCrack();
    this.getCrackStatuses();
  }

  LoadJobRoles() {
    this._user.getUserJobRoles().subscribe(roles => {
      roles.forEach(r => {
        switch (r.Name) {
          case 'Inspectors':
            this.isJobRoleDefault = false;
            this.isInspector = true;
            break;
          case 'Interpreters':
            this.isJobRoleDefault = false;
            break;
          case 'Super User':
            this.isJobRoleDefault = false;
            break;
          case 'Administrator':
            this.isJobRoleDefault = false;
            this.isAdministrator = true;
            break;
          case 'Supervisor':
            this.isJobRoleDefault = false;
            this.isAdministrator = true;
            break;
          case 'Customer Admin':
            this.isJobRoleDefault = false;
            break;
        }
      });

    })
  }
  // Implement Makes
  loadMakes() {
    this._implementService.GetImplementMakes().subscribe(r => {
      this.makeList = r;
    });
  }

  loadEquipmentDetails() {
    this._moduleService.returnEquipmentForGET(this.ImplementId.toString()).subscribe(equipment => {
      this.equipmentDetails = equipment;
      //this.loadObservationPointsForImplement();
      this.CustomerId = this.equipmentDetails.CustomerId;

      this.SMU = this.equipmentDetails.Smu;
      this.ltd = this.equipmentDetails.Ltd;

      this.equipmentId = this.equipmentDetails.equipmentId;
      //console.log(this.equipmentDetails)
      this.CheckCrackSeverityListForCustomer();
      this.getGETWearSurfaceReportSyle();
    });

  }

  getGETWearSurfaceReportSyle() {
    this._equipmentDetailsService.GetGETWearSurfaceReportStyle(this.equipmentDetails.equipmentId, this.ImplementId).subscribe(res => {
      if (res != null) {
        this.wearStyleId = res;
      }
    })
  }
  SMU: number = -1;
  equipmentId: number = 0;
  hasCrack: boolean = false;

  loadAssetDetails() {
    //this.loading = true; 
    this._moduleService.GetSchematicsImageIdsForImplement(this.ImplementId).subscribe(details => {
      this.SchematicAndObservationPoints = details;
      //this.loading = false
      this.loadAssetHeaderDetails();
    });
  }

  loadAssetHeaderDetails() {
    this._moduleService.GetImplementSchematicsAndObservationPointsHeaderData(this.ImplementId).subscribe(details => {
      this.ImplementSummaryForEquipmentDetails = details;
      //console.log("this.ImplementSummaryForEquipmentDetails: loadAssetHeaderDetails: ", this.ImplementSummaryForEquipmentDetails);
      this.hasCrack = this.ImplementSummaryForEquipmentDetails.TotalCracks > 0 ? true : false;
      //this.GetWarrantyTypesforImplement();
      if (this.equipmentDetails != undefined)
        this.equipmentDetails.PercentWorn = this.ImplementSummaryForEquipmentDetails.CrirticalWorstWorn;
    });
  }

  loadImplementDetails() {
    if (this.ImplementForEquipmentDetails == undefined || this.ImplementForEquipmentDetails == null || this.ImplementForEquipmentDetails.length == 0) {
      this.loading = true;
      this._moduleService.GetSchematicsForImplement(this.ImplementId).subscribe(details => {
        //console.log("ImplementForEquipmentDetails.................: ", details);
        this.ImplementForEquipmentDetails = details;
        console.log("this.ImplementForEquipmentDetails: loadImplementDetails: ", this.ImplementForEquipmentDetails);
        this.loading = false
        this.GetWarrantyTypesforImplement();
        this.equipmentDetails.PercentWorn = this.ImplementForEquipmentDetails[0].ImplementSummary.CrirticalWorstWorn;
        //this.ImplementForEquipmentDetails[0].SchematicAndObservationPoints.map(x => {
        //  x.ObservationPoints.map(f => {
        //    if (f.Type == 'Crack') {
        //      this.hasCrack = true;
        //      //return;
        //    }
        //  })
        //})
      });
    }
  }

  loadImplementDetailsHistroy() {
    //console.log("this.AssetDetailsHistroy:", this.AssetDetailsHistroy);
    if (this.AssetDetailsHistroy == undefined || this.AssetDetailsHistroy == null) {
      //console.log("this.AssetDetailsHistroy: In", this.AssetDetailsHistroy);
      this.loading = true;
      this._moduleService.GetAssestDetailHistroyInfo(this.ImplementId).subscribe(details => {
        this.AssetDetailsHistroy = details;
        this.loading = false
      });
    }
  }

  //checkCrack() {
  //  this._moduleService.CheckCrackForObsPoints(this.implementId).subscribe(crack => {
  //    console.log("iscrack: ", crack);
  //    this.hasCrack = crack;
  //  })
  //}

  historyDetails_: ImplementHistoryVM[] = [];
  cycleDetails: ImplementCycleDetails[] = [];
  //cycleDetails_:ImplementCycleDetails[]=[];
  loadEquipmentInspectionDetails() {
    this._moduleService.GetEquipmentInspectionHistoryForImplement(this.ImplementId).subscribe(inspections => {
      this.inspectionDetails = inspections;
      //console.log(inspections)
    })

    //this.loadImplementHistoryDetails()
  }

  loadImplementHistoryDetails() {
    //console.log("this.historyDetails_:", this.historyDetails_.length);
    if (this.historyDetails_.length == 0 || this.updateCost) {
      this.loading = true;
      //console.log("this.historyDetails_ In:", this.historyDetails_);
      this._moduleService.GetImplementHistoryDetails(this.ImplementId).subscribe(res => {
        this.historyDetails_ = res
        this.loading = false;
        //console.log("result", this.historyDetails_)
        //this.historyDetails_ = this.historyDetails_.filter(x => x.ActionDate != null);
        //get replace component info - 16 = Crack Fixed, 18	= Re-Cracked, 19	= Un-Repaired
        let replacedcomponentsActions = this.historyDetails_.filter(x => x.ActionName == 'Component Replacement' || x.ActionName == 'Component Repair' || x.ActionAuto == 16 || x.ActionAuto == 18 || x.ActionAuto == 19);
        if (replacedcomponentsActions != null) {
          replacedcomponentsActions.map(x => {
            this._moduleService.GetReplaceComponentName(x.ActionId).subscribe(res => {
              if(res.m_Item1 != ""){
                x.ActionName = x.ActionName + ' ( ' + res.m_Item1 + ' )';
              }
              if (res.m_Item2 == true)
              {
                x.GETCost = x.Cost;
                x.Cost = x.GETCost + x.Cost;
              }
              else x.GETCost = 0;
            })
          })
        }
        this.loadCycleDetails();
      })
    }
  }

  NewCycleList: any[] = [];
  NewCycleList_: any[] = [];

  newDAte: Date
  loadCycleDetails() {
    this._moduleService.GetImplementCycleDetails(this.ImplementId).subscribe(res => {

      let smuTotal = 0
      this.cycleDetails = res;
      this.cycleDetails.map(x => {
        let CycleTotals = []
        this.historyDetails_.map(y => {

          let ActionDate = new Date(y.ActionDate).getTime()
          let StartDate = new Date(x.StartDate).getTime()
          let EndDate;
          var dateOffset = (24 * 60 * 60 * 1000) * 1;
          if (x.EndDate == null) {
            EndDate = new Date().getTime()
            if (this.newDAte != null)
              StartDate = new Date(this.newDAte).getTime() + dateOffset;
          } else {
            EndDate = new Date(x.EndDate).getTime() - dateOffset;
            this.newDAte = EndDate;
          }
          // if (ActionDate >= StartDate && ActionDate <= EndDate ) {
          //     CycleTotals.push(y);
          // }

          if (y.CycleNo == x.CycleNo) {
            CycleTotals.push(y);
          }
          let maxSMU = Math.max.apply(Math, CycleTotals.map(function (o) { return o.HoursDiff; }))
          // let minSMU = Math.min.apply(Math, CycleTotals.map(function(o) { return o.Hours; }))
          let TotalSMU = maxSMU;

          let maxBCM = Math.max.apply(Math, CycleTotals.map(function (o) { return o.BCM; }))
          let minBCM = Math.min.apply(Math, CycleTotals.map(function (o) { return o.BCM; }))
          let TotalBCM = 0;//maxBCM - minBCM;

          let maxTon = Math.max.apply(Math, CycleTotals.map(function (o) { return o.Tons; }))
          let minTon = Math.min.apply(Math, CycleTotals.map(function (o) { return o.Tons; }))
          let TotalTon = 0;// maxTon - minTon;
          let totalcost = 0
          let totalCapitalcost = 0
          let totalMaintenancecost = 0
          let totalGETcost = 0
          console.log("CycleTotals:", CycleTotals);
          CycleTotals.map(x => {

            totalcost = totalcost + x.Cost;
            totalCapitalcost = totalCapitalcost + x.CapitalCost;
            totalMaintenancecost = totalMaintenancecost + x.MaintenanceCost;
            TotalBCM = TotalBCM + x.BCM
            TotalTon = TotalTon + x.Tons;
            totalGETcost = totalGETcost + x.GETCost;
            console.log("Cost:", totalcost, totalCapitalcost, totalMaintenancecost, totalGETcost);
          })

          if (TotalSMU == -Infinity)
            TotalSMU = 0
          if (TotalBCM == -Infinity)
            TotalBCM = 0
          if (TotalTon == -Infinity)
            TotalTon = 0
          x["newArray"] = CycleTotals;
          x["TotalSMU"] = TotalSMU;
          x["TotalBCM"] = TotalBCM;
          x["TotalTon"] = TotalTon;
          x["TotalCost"] = totalcost;
          x["TotalCapitalCost"] = totalCapitalcost;
          x["TotalMaintenanceCost"] = totalMaintenancecost;
          x["TotalGETCost"] = totalGETcost;



        })

        //console.log("newlist",this.cycleDetails)
        this.NewCycleList = this.cycleDetails;
        this.NewCycleList_ = this.cycleDetails;
        if (this.NewCycleList != null) {
          this.GetTotalsDetails();
        }
        //console.log("Cycle actions" ,CycleTotals)
      })
    })

  }
  totalcost: number = 0;
  totalCapitalcost: number = 0;
  totalMaintenancecost: number = 0;
  totalGETcost: number = 0;


  totalsmu: number = 0;
  totalbcm: number = 0;
  totaltons: number = 0;
  totalcycle: number;
  GetTotalsDetails() {
    let cost = 0;
    let Maintenancecost = 0;
    let Capitalcost = 0;
    let GETcost = 0;

    let smu = 0;
    let bcm = 0;
    let ton = 0;
    //TT-4377
    // this.NewCycleList_.map((y,index)=>{
    //     if(index!=0){
    //         let previusSMu = this.NewCycleList_[index-1].TotalSMU;
    //         y.TotalSMU = y.TotalSMU -previusSMu;
    //     }
    // })


    this.NewCycleList.map((x, index) => {
      let totalcost = 0;
      // if (index != 0 && index > 0) {

      //     //let previusSMu = this.NewCycleList_[index-1].TotalSMU;
      //     //  x.TotalSMU = x.TotalSMU -previusSMu;


      //     // x.TotalSMU = x.TotalSMU> 0?  x.TotalSMU-previusSMu:0;

      // }
      if (x.newArray != null) {

        let filterArray = x.newArray.filter(z => z.CycleNo == x.CycleNo);
        let maxCycleCMU = Math.max.apply(Math, filterArray.map(function (o) { return o.CycleCMU; }))
        x.TotalSMU = maxCycleCMU;

        //console.log(x, "filterArray",filterArray);
        // filterArray.map(z=>{
        //     totalcost = totalcost + z.Cost;
        // })

        //console.log(x, "xxxyyyy");
      }



      //x.TotalCost = totalcost;

      cost = cost + x.TotalCost;
      Maintenancecost = Maintenancecost + x.TotalMaintenanceCost;
      Capitalcost = Capitalcost + x.TotalCapitalCost;
      GETcost = GETcost + x.TotalGETCost;


      smu = smu + x.TotalSMU
      bcm = bcm + x.TotalBCM
      ton = ton + x.TotalTon
    })
    this.totalcycle = Math.max.apply(Math, this.NewCycleList.map(function (o) { return o.CycleNo; }))
    this.totalcost = cost;
    this.totalMaintenancecost = Maintenancecost;
    this.totalCapitalcost = Capitalcost;
    this.totalGETcost = GETcost;


    this.totalsmu = smu
    this.totalbcm = bcm
    this.totaltons = ton;

  }

  ToDecimalPoints(val1, val2) {
    if (val1 > 0) {
      let costper = val1 / val2;
      if (costper == Infinity || Number.isNaN(costper)) {
        costper = 0;
      }
      return costper.toFixed(2);
    } if (val2 == 0 && val2 == 0) {
      return 0;
    }

  }


  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
  getEvalClass(wornPct: number) {
    if (wornPct <= 30) {
      return " WornPctCell evalColorA";
    }
    else if ((wornPct > 30) && (wornPct <= 60)) {
      return " WornPctCell evalColorB";
    }
    else if ((wornPct > 60) && (wornPct <= 80)) {
      return " WornPctCell evalColorC";
    }
    else if (wornPct > 80) {
      return "WornPctCell evalColorX";
    }
    return " WornPctCell noEval";
  }

  getEvalCode(evalcode: string) {
    if (evalcode == 'A') {
      // return "evalColorACode";
      return " WornPctCell evalColorA";
    }
    else if (evalcode == 'B') {
      //return "evalColorBCode";
      return " WornPctCell evalColorB";
    }
    else if (evalcode == 'C') {
      //return "evalColorCCode";
      return " WornPctCell evalColorC";
    }
    else if (evalcode == 'X') {
      //return "evalColorXCode";
      return "WornPctCell evalColorX";
    }
    return " noEvalCode";
  }



  //open move to invetory
  openRemoveImplementModal() {
    let openRemoveImplementModalRef = this.removeImplementModal.open(RemoveImplementModalComponent, {
      width: '550px',
      disableClose: true,
      data: {
        implementId: this.ImplementId,
        jobsiteId: this.equipmentDetails.JobsiteId,
        jobsiteName: this.equipmentDetails.JobsiteName,
        equipmentId: this.equipmentDetails.equipmentId,
        equipmentSMU: this.equipmentDetails.Smu,
      }
    });
    openRemoveImplementModalRef.afterClosed().subscribe(() => {
      this.initialise();
    });
  }


  //open Perfom Inspection
  openPerformInspectionModal() {
    //console.log("this.ImplementForEquipmentDetails[0]:", this.ImplementForEquipmentDetails[0]);
    let openPerformInspectionModalRef = this.attachImplementModal.open(PerformInspectionComponent, {
      width: '550px',
      disableClose: true,
      data: {
        implementId: this.ImplementId,
        CustomerId: this.equipmentDetails.CustomerId,
        CustomerName: this.equipmentDetails.CustomerName,
        jobsiteId: this.equipmentDetails.JobsiteId,
        jobsiteName: this.equipmentDetails.JobsiteName,
        //implementName: this.ImplementForEquipmentDetails[0].ImplementSummary.Name
        implementName: this.ImplementSummaryForEquipmentDetails.Name
      }
    });
    openPerformInspectionModalRef.afterClosed().subscribe(() => {
      this.initialise();
    });
  }

  //open Move from inventory
  openAttachImplementModal() {
    let openAttachImplementModalRef = this.attachImplementModal.open(AttachImplementModalComponent, {
      width: '550px',
      disableClose: true,
      data: {
        implementId: this.ImplementId,
        jobsiteId: this.equipmentDetails.JobsiteId,
        jobsiteName: this.equipmentDetails.JobsiteName,
        //implementName: this.ImplementForEquipmentDetails[0].ImplementSummary.Name
        implementName: this.ImplementSummaryForEquipmentDetails.Name
      }
    });
    openAttachImplementModalRef.afterClosed().subscribe(() => {
      this.initialise();
    });
  }


  //change status 
  openChangeStatusModal() {
    if (this.isJobRoleDefault == false) {
      if (this.showImplementStatusModal) {
        let changeStatusModalRef = this.changeStatusModal.open(ImplementStatusModalComponent, {
          width: '550px',
          disableClose: true,
          data: {
            implementId: this.ImplementId,
            jobsiteId: this.equipmentDetails.JobsiteId,
            jobsiteName: this.equipmentDetails.JobsiteName,
          }
        });
        changeStatusModalRef.afterClosed().subscribe(() => {
          this.initialise();
        });
      }
    }



  }


  //open update meter unit dialog

  openUpdateMeter() {
    const updateMeterDialog = this.changeStatusModal.open(GETUpdateMeterComponent, {
      panelClass: 'removeModalOverflow',
      disableClose: true,
      data: {
        equipmentId: this.equipmentDetails.equipmentId,
        customerId: this.equipmentDetails.CustomerId,
        smuPrechange: this.equipmentDetails.Smu,
        lastUpdateTime: this.equipmentDetails.LastInspectionDate,
        bcmPrechange: this.equipmentDetails.Bcm,
        tonPrechange: this.equipmentDetails.Ton,
        implementId: this.ImplementId,
      }
    });

    const instance = updateMeterDialog.componentInstance;
    instance.changeLateUpdateTime(this.equipmentDetails.LastInspectionDate);

    updateMeterDialog.afterClosed().subscribe(newMeterReading => {
      if (newMeterReading === undefined)

        return;

      if (newMeterReading) {
        this.loadEquipmentDetails();
        this.initialise();
        // this.loadEquipmentSystems();
      }
    });
  }

  //open change jobsite equipment

  openChangeJobsite() {
    const dialogRef = this.changeStatusModal.open(GETChangeJobsiteComponent, {
      panelClass: 'removeModalOverflow',
      disableClose: true,
      data: {
        equipmentId: this.equipmentDetails.equipmentId,
        customerId: this.equipmentDetails.CustomerId
      }
    });

    dialogRef.afterClosed().subscribe(newJobsiteName => {
      if (newJobsiteName == null || newJobsiteName === undefined)
        return;
      if (newJobsiteName !== this.equipmentDetails.JobsiteName) {
        // this.equipmentDetails.JobsiteName = newJobsiteName;
        this.loadEquipmentDetails();
      }
    });
  }


  //open chnage jobsite Inventory
  openChangeJobsiteInventory() {
    const dialogRef = this.changeStatusModal.open(GETChangeJobsiteComponent, {
      panelClass: 'removeModalOverflow',
      disableClose: true,
      data: {
        implementId: this.ImplementId,
      }
    });

    dialogRef.afterClosed().subscribe(newJobsiteName => {
      if (newJobsiteName == null || newJobsiteName === undefined)
        return;
      if (newJobsiteName !== this.equipmentDetails.JobsiteName) {
        // this.equipmentDetails.JobsiteName = newJobsiteName;
        this.loadEquipmentDetails();
      }
    });
  }

  //open Implemtn action
  openImplementAction() {
    const dialogRef = this.changeStatusModal.open(ImplementActionComponent, {
      panelClass: 'removeModalOverflow',
      disableClose: true,

      data: {
        equipmentId: this.equipmentDetails.equipmentId,
        customerId: this.equipmentDetails.CustomerId,
        jobsiteId: this.equipmentDetails.JobsiteId,
        currentSmu: this.equipmentDetails.Smu,
        implementId: this.ImplementId,
        IsPendingAssetActions: this.equipmentDetails.IsPendingAssetActions
      }
    });

    dialogRef.afterClosed().subscribe(r => {
      this.initialise();
    });
  }


  //open Rebuild Implement
  openRebuildImplement() {
    const dialogRef = this.changeStatusModal.open(ImplementRebuildDialogComponent, {
      width: '1200px',
      height: '810px',
      panelClass: 'removeModalOverflow',
      disableClose: true,
      data: {
        implementId: this.ImplementId,
        customerId: this.equipmentDetails.CustomerId,
        //implementName: this.ImplementForEquipmentDetails[0].ImplementSummary.Name,
        implementName: this.ImplementSummaryForEquipmentDetails.Name,
        jobsiteId: this.equipmentDetails.JobsiteId,
        jobsiteName: this.equipmentDetails.JobsiteName,
      }
    });

    dialogRef.afterClosed().subscribe(r => {
      this.initialise();
    });
  }

  //open Complete Rebuild Implement
  CompleteRebuild() {
    const dialogRef = this.changeStatusModal.open(ImplementRebuildCompleteDialogComponent, {
      panelClass: 'removeModalOverflow',
      disableClose: true,
      data: {
        implementId: this.ImplementId,
        customerId: this.equipmentDetails.CustomerId,
        //implementName: this.ImplementForEquipmentDetails[0].ImplementSummary.Name,
        implementName: this.ImplementSummaryForEquipmentDetails.Name,
        jobsiteId: this.equipmentDetails.JobsiteId,
        jobsiteName: this.equipmentDetails.JobsiteName,
      }
    });

    dialogRef.afterClosed().subscribe(r => {
      this.initialise();
    });
  }

  //open Complete Rebuild Implement
  openUpdateTargets() {
    const dialogRef = this.changeStatusModal.open(ImplementTargetsUpdateComponent, {
      panelClass: 'removeModalOverflow',
      disableClose: true,
      data: {
        implementId: this.ImplementId,
        customerId: this.equipmentDetails.CustomerId,
        //implementName: this.ImplementForEquipmentDetails[0].ImplementSummary.Name,
        implementName: this.ImplementSummaryForEquipmentDetails.Name,
        jobsiteId: this.equipmentDetails.JobsiteId,
        jobsiteName: this.equipmentDetails.JobsiteName,
      }
    });

    dialogRef.afterClosed().subscribe(r => {
      this.initialise();
    });
  }


  openLink(target: string, date: string, selectedInspection: InspectionHistoryDetails) {
    // console.log()
    const dateTime = new Date(selectedInspection.ActualDate);
    const gotday = dateTime.getDate();
    const gotmonth = dateTime.getMonth() + 1;
    const gotyear = dateTime.getFullYear();

    if (target == 'impinspection') {
      // this._router.navigate(['/get-interpretation/inspection', this.equipmentDetails.equipmentId, selectedInspection.ImplementInspectionId]);
      //   window.open('/get-interpretation/inspection/' + this.equipmentDetails.equipmentId + '/' + selectedInspection.ImplementInspectionId, '_blank')

      this._pref.GetReplaceExistingTabStatus().subscribe(res => {
        if (res == "True") {
          this._router.navigate(['/get-interpretation/inspection', this.equipmentDetails.equipmentId, selectedInspection.ImplementInspectionId]);
        } else {
          window.open('/get-interpretation/inspection/' + this.equipmentDetails.equipmentId + '/' + selectedInspection.ImplementInspectionId, '_blank')

        }
      });

    }
    else if (target === 'inspection') {
      //this._router.navigate(['/get-interpretation', this.equipmentDetails.equipmentId, gotyear, gotmonth, gotday]);
      //  window.open('/get-interpretation/' + this.equipmentDetails.equipmentId + '/' + gotyear + '/' + gotmonth + '/' + gotday, '_blank')

      this._pref.GetReplaceExistingTabStatus().subscribe(res => {
        if (res == "True") {
          this._router.navigate(['/get-interpretation', this.equipmentDetails.equipmentId, gotyear, gotmonth, gotday]);
        } else {
          window.open('/get-interpretation/' + this.equipmentDetails.equipmentId + '/' + gotyear + '/' + gotmonth + '/' + gotday, '_blank')

        }
      });

    }
    //else if (target === 'pdf') {
    //    try {
    //        var dateParts = date.split('/');
    //        var months = [
    //            { id: "01", name: "Jan" },
    //            { id: "02", name: "Feb" },
    //            { id: "03", name: "Mar" },
    //            { id: "04", name: "Apr" },
    //            { id: "05", name: "May" },
    //            { id: "06", name: "Jun" },
    //            { id: "07", name: "Jul" },
    //            { id: "08", name: "Aug" },
    //            { id: "09", name: "Sep" },
    //            { id: "10", name: "Oct" },
    //            { id: "11", name: "Nov" },
    //            { id: "12", name: "Dec" }
    //        ];

    //        var day = dateParts[0];
    //        var month = months.find(f => f.name == dateParts[1]).id;
    //        var year = dateParts[2];

    //        var dateParsed = year + month + day;

    //        switch (target) {
    //            // case 'inspection':
    //            //     //window.open(this.appUris.GETUri + 'inspection/' + dateParsed, '_blank');
    //            //     break;
    //            case 'pdf':
    //                if (this.equipmentDetails.equipmentId == 0) {
    //                    window.open(this.appUris.UCUri + 'api/GETinspection/GetPdfonInventory?inspectionid=' + selectedInspection.ImplementInspectionId + '&date=' + dateParsed + '&styleId=' + this.wearStyleId, '_blank');
    //                } else {
    //                    window.open(this.appUris.UCUri + 'api/GETinspection/GetPdf?id=' + this.equipmentDetails.equipmentId + '&date=' + dateParsed + '&styleId=' + this.wearStyleId, '_blank');
    //                }

    //                break;
    //        }
    //    } catch (e) {
    //        //console.log(e);
    //    }
    //}
    //added by Hans Raj Sharma as on 10 Jan 2023
    else if (target === 'pdf' || target === 'TelerikPdf') {
      try {
        var dateParts = date.split('/');
        var months = [
          { id: "01", name: "Jan" },
          { id: "02", name: "Feb" },
          { id: "03", name: "Mar" },
          { id: "04", name: "Apr" },
          { id: "05", name: "May" },
          { id: "06", name: "Jun" },
          { id: "07", name: "Jul" },
          { id: "08", name: "Aug" },
          { id: "09", name: "Sep" },
          { id: "10", name: "Oct" },
          { id: "11", name: "Nov" },
          { id: "12", name: "Dec" }
        ];
        var day = dateParts[0];
        var month = months.find(f => f.name == dateParts[1]).id;
        var year = dateParts[2];
        var dateParsed = year + month + day;
        switch (target) {
          case 'pdf':
            if (this.equipmentDetails.equipmentId == 0) {
              window.open(this._appService.getBaseURL() + 'api/GETinspection/GetPdfonInventory?inspectionid=' + selectedInspection.ImplementInspectionId + '&date=' + dateParsed + '&styleId=' + this.wearStyleId, '_blank');
            } else {
              window.open(this._appService.getBaseURL() + 'api/GETinspection/GetPdf?id=' + this.equipmentDetails.equipmentId + '&date=' + dateParsed + '&styleId=' + this.wearStyleId, '_blank');
            }
            break;
          case 'TelerikPdf':
            window.open(this._appService.getBaseURL() + 'api/GETinspection/GetPdf?inspectionid=' + selectedInspection.ImplementInspectionId + '&EquipmentId=' + this.equipmentDetails.equipmentId + '&GetType=' + selectedInspection.GETTypeId + '&styleId=' + this.wearStyleId, '_blank');
            break;
        }
      } catch (e) {
        //console.log(e);
      }
    }

  }

  GenerateTrayPDF(date: string, selectedInspection: InspectionHistoryDetails) {
    //this.date = inspectionDate.toString();
    var dateParts = date.split('/');
    var months = [
      { id: "01", name: "Jan" },
      { id: "02", name: "Feb" },
      { id: "03", name: "Mar" },
      { id: "04", name: "Apr" },
      { id: "05", name: "May" },
      { id: "06", name: "Jun" },
      { id: "07", name: "Jul" },
      { id: "08", name: "Aug" },
      { id: "09", name: "Sep" },
      { id: "10", name: "Oct" },
      { id: "11", name: "Nov" },
      { id: "12", name: "Dec" }
    ];

    var day = dateParts[0];
    var month = months.find(f => f.name == dateParts[1]).id;
    var year = dateParts[2];

    var dateParsed = year + month + day;

    if (this.equipmentDetails.equipmentId == 0) {
      window.open(this._appService.getBaseURL() + 'api/GETinspection/GetTrayPdfonInventory?inspectionid=' + selectedInspection.ImplementInspectionId + '&date=' + dateParsed + '&styleId=' + 1, '_blank');

    } else {
      window.open(this._appService.getBaseURL() + 'api/GETinspection/GetTrayPdf?id=' + this.equipmentDetails.equipmentId + '&date=' + dateParsed + '&styleId=' + this.wearStyleId, '_blank');

    }

  }

  GenerateTelerikPDF(date: string, selectedInspection: InspectionHistoryDetails) {
    window.open(this._appService.getBaseURL() + 'api/GETinspection/GetPdf?inspectionid=' + selectedInspection.ImplementInspectionId + '&EquipmentId=' + this.equipmentDetails.equipmentId + "&GetType=" + selectedInspection.GETTypeId + '&styleId=' + this.wearStyleId, '_blank');
  }
  ///////////////////////////////////////old code /////////////////////////////////////////
  reloadDetails() {
    this.route.params.subscribe(params => {
      this.ImplementId = +params['implementId'];

      // Implement details.
      this._moduleService.returnGETById(this.ImplementId.toString()).subscribe(res => {
        var result = JSON.parse(res.toString());

        if (result != null) {
          this.implement = result;

          if (this.implement.lastInspection != "N/A") {
            //this.implement.lastInspection = this.dateParser.formatDateOrdinal(result.lastInspection, true);
            this.implement.lastInspection = result.lastInspection;
          }
          if (this.implement.status != "N/A") {
            var statusDesc = "This implement is currently ";
            var repairerDesc = this.implement.repairerName;
            var workshopDesc = this.implement.workshopName;

            if (this.implement.status == "On Equipment") {
              this.implementStatusText = this.implement.status;
              this.implementStatusDesc = statusDesc + "on an equipment. ";
              this.showChangeJobsiteModal = false;
              this.showRemoveImplementModal = true;
              this.showAttachImplementModal = false;
              this.showImplementStatusModal = false;
              this.showRepairOrReplaceModal = false;
            }
            else {

              this.implementStatusText = "In Inventory " + this.implement.status;
              this.implementStatusDesc = statusDesc + this.implement.status + ".";
              if ((repairerDesc != "") && (workshopDesc != "")) {
                this.implementStatusDesc += " It has been assigned to the repairer <b>"
                  + repairerDesc + "</b> at <b>" + workshopDesc + "</b>.";
              }

              this.showChangeJobsiteModal = true;
              this.showRemoveImplementModal = false;
              // GET-113: Equipment Awaiting Repair Validation
              var readyForUse_string = "Ready for Use";
              if (this.implement.status.toLowerCase() == readyForUse_string.toLowerCase()) {
                this.showAttachImplementModal = true;
              } else {
                this.showAttachImplementModal = false;
              }
              this.showImplementStatusModal = true;
              this.showRepairOrReplaceModal = true;
              this.SMU = -1;
              this.equipmentId = 0;
            }
          }


          //this.pageTitle = this.implement.serialNo + " Details (" + this.implement.implementType + ")";
          this.showImplement = true;
        } else {
          this.implement.customer = "";
          this.implement.jobsite = "";
          this.implement.make = "";
          this.implement.model = "";
          this.implement.life = 0;
          this.implement.serialNo = "";
          this.implement.implementType = "";
          this.implement.lastInspection = "";
          this.implement.status = "";

          this.showImplement = false;
        }
        //this._appService.setPageTitle(this.pageTitle);
      }, error => { console.log(error); });


      // Inspection Details
      this._moduleService.returnInspectionDetailsForGET(this.ImplementId.toString()).subscribe(res => {
        var result = JSON.parse(res.toString());

        if (result != null) {
          this.inspections = result;

          for (var i = 0; i < this.inspections.length; i++) {
            this.inspections[i].inspectionDate = this.dateParser.formatDateOrdinal(this.inspections[i].inspectionDate, false);
          }

          this.showInspections = true;
        } else {
          this.showInspections = false;
        }

      }, error => { console.log(error); });

      // GET Component Details
      this._moduleService.returnComponentsForGET(this.ImplementId.toString()).subscribe(res => {
        var result = JSON.parse(res.toString());

        if (result != null) {
          this.getComponents = result;
          this.showComponents = true;
        } else {
          this.showComponents = false;
        }

      }, error => { console.log(error); });

      // Implement History
      this._moduleService.returnHistoryForGET(this.ImplementId.toString()).subscribe(res => {
        var result = JSON.parse(res.toString());

        if (result != null) {
          this.implementHistory = result;

          for (var i = 0; i < this.implementHistory.length; i++) {
            this.implementHistory[i].date = this.dateParser.formatDateOrdinal(this.implementHistory[i].date, false);
          }

          this.showHistory = true;
        } else {
          this.showHistory = false;
        }
      })
    });
  }







  openRecordRepairModal(id, name) {
    let openRecordRepairModalRef = this.recordRepairModal.open(RecordRepairModalComponent, {
      width: '550px',
      data: {
        jobsiteId: this.implement.jobsiteId,
        jobsiteName: this.implement.jobsite,
        componentId: id,
        componentName: name
      }
    });
    openRecordRepairModalRef.afterClosed().subscribe(() => {
      //this.reloadDetails();
    })
  }

  openRecordReplaceModal(id, name) {
    let openRecordReplaceModalRef = this.recordReplaceModal.open(RecordReplaceModalComponent, {
      width: '550px',
      data: {
        jobsiteId: this.implement.jobsiteId,
        jobsiteName: this.implement.jobsite,
        componentId: id,
        componentName: name
      }
    });
    openRecordReplaceModalRef.afterClosed().subscribe(() => {
      // this.reloadDetails();
    })
  }

  openChangeImplementJobsiteModal() {
    let changeImplementJobsiteModalRef = this.changeImplementJobsiteModal.open(ChangeImplementJobsiteModalComponent, {
      width: '550px',
      data: { implementId: this.ImplementId }
    });
    changeImplementJobsiteModalRef.afterClosed().subscribe(() => {
      // this.reloadDetails();
    });
  }

  // Determine the eval colours to use.
  determineEvalColour(val) {
    if (val <= this.THRESHOLD_EVAL_A) {
      return 'eval-a';
    } else if ((val > this.THRESHOLD_EVAL_B_MIN) && (val <= this.THRESHOLD_EVAL_B_MAX)) {
      return 'eval-b';
    } else if ((val > this.THRESHOLD_EVAL_C_MIN) && (val <= this.THRESHOLD_EVAL_C_MAX)) {
      return 'eval-c';
    } else {
      return 'eval-x';
    }
  }

  // openInspection(id) {
  //     var uri = 'http://' + this.GETUri + '/GET/InspectionDetails.aspx' + '?i=' + id;
  //     window.open(uri, '');
  // }

  mouseOverStatus() {
    this.statusChange.nativeElement.style.background = "#85888B";
  }

  mouseLeaveStatus() {
    this.statusChange.nativeElement.style.background = "#1D2F36";
  }

  openSchematic(): void {
    let schematicViewModalRef = this.schematicViewComponent.open(SchematicViewComponent, {
      width: '720px',
      height: '695px',
      data: { implementId: this.ImplementId }
    });
    schematicViewModalRef.afterClosed().subscribe(() => {

    });
  }

  //open Document Library
  openDocumentLibrary() {
    const dialogRef = this.changeStatusModal.open(DocumentLibraryComponent, {
      // panelClass: 'removeModalOverflow',
      width: '1000px',
      disableClose: true,

      data: {
        ImplementModelId: 3,
        ImplementId: this.ImplementId
      }
    });

    dialogRef.afterClosed().subscribe(r => {
      // this.initialise();
    });
  }
  //open product improvement
  openProductImprovement() {
    const dialogRef = this.changeStatusModal.open(ProductImprovementImplementDialogComponent, {

      disableClose: true,

      data: {
        ImplementId: this.ImplementId

      }
    });

    dialogRef.afterClosed().subscribe(r => {
      // this.initialise();
    });
  }

  OpenExisitingImp() {
    //console.log()
    //this._router.navigate(['/setup/existing-implement-new/', this.implementId]);

    this._router.navigate([]).then(result => { window.open('/setup/existing-implement-new/' + this.ImplementId, '_blank'); });
  }

  OpenCopyAdvanced() {
    // window.open('/copy/implement/advance/' + this.ImplementId, '_blank');
    this._pref.GetReplaceExistingTabStatus().subscribe(res => {
      if (res == "True") {
        this._router.navigate(['/copy/implement/advance', this.ImplementId],
          {
          queryParams: { source: 'template' }
        });
      } else {
        window.open('/copy/implement/advance/' + this.ImplementId + '?source=template', '_blank');
      }
    });
  }


  //open Document Library
  openAttachedDocs(SMU, Date, InspectionId) {
    const dialogRef = this.changeStatusModal.open(InspectionAttachedDocsComponent, {
      width: '50%',
      disableClose: true,

      data: {
        InspectionDate: Date,
        SMU: SMU,
        InspectionId: InspectionId,
        IsUC: false,
      }
    });

    dialogRef.afterClosed().subscribe(r => {
      this._moduleService.GetEquipmentInspectionHistoryForImplement(this.ImplementId).subscribe(inspections => {
        this.inspectionDetails = inspections;
        //console.log(inspections)
      })
    });
  }

  //open Warranty Status

  openWarrantyStatus(SMU, Date, InspectionId) {
    //console.log("this.ImplementForEquipmentDetails[0].ImplementSummary.Life", this.ImplementForEquipmentDetails[0].ImplementSummary.Life)
    const dialogRef = this.changeStatusModal.open(WarrantyStatusDialogComponent, {
      width: '50%',
      disableClose: true,

      data: {
        ImplementId: this.ImplementId,
        SMU: this.SMU,
        equipmentDetails: this.equipmentDetails,
        showImplementStatusModal: this.showImplementStatusModal,
        //CMU: this.ImplementForEquipmentDetails[0].ImplementSummary.Life,
        CMU: this.ImplementSummaryForEquipmentDetails.Life,
        equipmentId: this.equipmentDetails.equipmentId,
      }
    });

    dialogRef.afterClosed().subscribe(r => {
      // this.initialise();

      this.loadEquipmentDetails();
      this.initialise();
    });
  }

  isExpired_: boolean = false;
  isExpiredWarranty: boolean = false;
  originalCMU: number = 0;
  startCMU: number = 0;
  numberofOriginalWarrantyDays: number;
  WarrantyTypeResidualDays: number;
  GetWarrantyTypesforImplement() {
    this._DocLibraryservice.GetWarrantyTypesforImplement(this.ImplementId).subscribe(res => {


      //this.originalCMU = this.ImplementForEquipmentDetails != null ? this.ImplementForEquipmentDetails[0].ImplementSummary.Life : 0;
      this.originalCMU = this.ImplementSummaryForEquipmentDetails != null ? this.ImplementSummaryForEquipmentDetails.Life : 0;

      if (res.ID > 0) {

        let currentDate = new Date();
        let startDate_ = new Date(res.startDate);
        this.numberofOriginalWarrantyDays = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(startDate_.getFullYear(), startDate_.getMonth(), startDate_.getDate())) / (1000 * 60 * 60 * 24));
        //  this.ResidualWarrantyHours=this.WarrantyTypeIntialHours-(this.meterReading-this.startSmu)
        this.WarrantyTypeResidualDays = res.WarrantyTypeIntialDays - this.numberofOriginalWarrantyDays


        this.startCMU = res.BucketCMU;
        this.startSmu = res.startSMU
        this.WarrantyTypeIntialHours = res.WarrantyTypeIntialHours
        this.ResidualWarrantyHours = (res.WarrantyTypeIntialHours - this.originalCMU) + this.startCMU;//this.WarrantyTypeIntialHours-(this.SMU-this.startSmu)
        this.isExpiredWarranty = res.isExpired;

        //check red  ans expired
        if ((this.ResidualWarrantyHours <= 0) || this.WarrantyTypeResidualDays <= 0) {

          this.isRed = true;
          this.isOrange = false
          this.isGray = false
          this.isGreen = false
          this.isExpired_ = true;
          if (this.isExpiredWarranty == false) {

            this.updateWarantyStatus();
          }
          return;

        }

        //only red but not expired
        else if ((this.ResidualWarrantyHours <= 100 && this.ResidualWarrantyHours > 0)) {
          console.log("red__ not expired1");
          this.isRed = true
          this.isOrange = false
          this.isGray = false
          this.isGreen = false
          this.isExpired_ = false;
          if (this.isExpiredWarranty == true) {


            this.updateWarantyStatus();
          }
          return;

        }

        //orange
        else if ((this.ResidualWarrantyHours > 100 && this.ResidualWarrantyHours <= 1500) || (this.WarrantyTypeResidualDays <= 30)) {

          this.isOrange = true
          this.isGray = false
          this.isGreen = false
          this.isRed = false;
          this.isExpired_ = false;
          if (this.isExpiredWarranty == true) {

            this.updateWarantyStatus();
          }
          return;

        }

        //green
        else if (this.ResidualWarrantyHours > 1500 || this.WarrantyTypeResidualDays > 30) {
          this.isGreen = true
          this.isGray = false
          this.isOrange = false
          this.isRed = false;
          this.isExpired_ = false;
          if (this.isExpiredWarranty == true) {
            this.updateWarantyStatus();
          }
          return;

        }


      }
      else {
        this.isRed = false;
        this.isOrange = false
        this.isGray = true
        this.isGreen = false
        this.isExpired_ = false;
      }


    })
  }

  updateWarantyStatus() {
    this._DocLibraryservice.recordExporedWarrantyforImplement(this.ImplementId).subscribe(res => {
    })
  }

  UpdateInventoryStatus() {
    this._inventoryService.UpdateInventoryStatusEquipmentForGET(this.ImplementId, this.equipmentDetails.InventoryStatus).subscribe((res: any) => {
      if (res != null) {
        if (res == 1) {
          this._notify.success('Success', 'Record updated successfully');
        }
      }
    })
  }


  EnablePreference: EnablePreferenceTasksVM
  GetPreferenceTaskList() {
    this._pref.getPreferenceTaskListForLoggedUser().subscribe(res => {
      this.EnablePreference = res
    })
  }

  openInspectionPlannerDialog() {
    const inspectionPlannerDialog = this.changeStatusModal.open(InspectionPlannerComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        equipmentId: this.equipmentId,
        isInspector: true
      },
      minWidth: 300
    });

    inspectionPlannerDialog.afterClosed().subscribe(result => {

      if (result) {
        this.loadEquipmentDetails();
      }
    });
  }

  tabChanged(tab) {
    console.log("tab:", tab.index);
    if (tab.index == 1)
      this.loadImplementHistoryDetails();
    else if (tab.index == 2) {
      this.loadImplementDetails();
      this.loadImplementDetailsHistroy();
    }
    else if (tab.index == 3) {
      this.loadImplementDetails();
    }
  }
  
  ShowHidefield() {
    this.showBar = !this.showBar
  }

  //MaintenanceCost section
  editMaintenanceCost(type: number) {
    this.currentClickedId = type;
    this.editableMaintenanceCost = false;
  }

  onCancelMaintenanceCost() {
    this.editableMaintenanceCost = true;
  }

  onSaveMaintenanceCost(ActionId : number, MaintenanceCost: number) {
    this.editableMaintenanceCost = true;
    this._moduleService.updateMaintenanceCost(ActionId, MaintenanceCost).subscribe((res: any) => {
      if (res != null) {
        if (res == 1) {
          this._notify.success('Success', 'Record updated successfully');
          this.updateCost = true;
          this.loadImplementHistoryDetails();
        }
        else {
          this._notify.error('Failed', 'Unable to save record. Please contact TrackTreads support.');
        }
      }
    });
  }

  //CapitalCost section
  editCapitalCost(type: number) {
    this.currentClickedId = type;
    this.editableCapitalCost = false;
  }

  onCancelCapitalCost() {
    this.editableCapitalCost = true;
  }

  onSaveCapitalCost(ActionId: number, CapitalCost: number) {
    this.editableCapitalCost = true;
    this._moduleService.updateCapitalCost(ActionId, CapitalCost).subscribe((res: any) => {
      if (res != null) {
        if (res == 1) {
          this._notify.success('Success', 'Record updated successfully');
          this.updateCost = true;
          this.loadImplementHistoryDetails();
        }
        else {
          this._notify.error('Failed', 'Unable to save record. Please contact TrackTreads support.');
        }
      }
    });
  }

  //BCM section
  editBCM(type: number) {
    this.currentClickedId = type;
    this.editableBCM = false;
  }

  onCancelBCM() {
    this.editableBCM = true;
  }

  onSaveBCM(EQBCMTonId: number, Cost: number) {
    this.editableBCM = true;
    this._moduleService.updateBCM(EQBCMTonId, this.equipmentId, Cost).subscribe((res: any) => {
      if (res != null) {
        if (res == 1) {
          this._notify.success('Success', 'Record updated successfully');
        }
        else {
          this._notify.error('Failed', 'Unable to save record. Please contact TrackTreads support.');
        }
      }
    });
  }

  //Tons section
  editTons(type: number) {
    this.currentClickedId = type;
    this.editableTons = false;
  }

  onCancelTons() {
    this.editableTons = true;
  }

  onSaveTons(EQBCMTonId: number, Cost: number) {
    this.editableTons = true;
    this._moduleService.updateTons(EQBCMTonId, this.equipmentId, Cost).subscribe((res: any) => {
      if (res != null) {
        if (res == 1) {
          this._notify.success('Success', 'Record updated successfully');
        }
        else {
          this._notify.error('Failed', 'Unable to save record. Please contact TrackTreads support.');
        }
      }
    });
  }

  CheckCrackSeverityListForCustomer() {
    this._inspectionService.CheckCrackSeverityListForCustomer(this.equipmentId).subscribe(r => {
      this.crackSeverityList = r;
      console.log("this.crackSeverityList:", this.crackSeverityList, this.equipmentId );
    });
  }

  singlePointCrackEntryHandler() {
    this._moduleService.singlePointCrackEntryHandler(this.ImplementId, this.implement.SinglePointCrackEntry).subscribe(r => {
      if (r)
        this._notify.success('Success', 'Record updated successfully');
    });
  }
  getCrackStatuses() {
    this._implementService.getCrackStatuses().subscribe({
      next: (res: CrackStatusVM[]) => {
        this.crackOptions = res.map(x => ({ ...x, isSelected: x.Id !== 1 }));
        console.log('crackOptions', this.crackOptions);
        this.activeCrackStatusIds = this.crackOptions.filter(o => o.isSelected).map(o => o.Id);
      },
      error: (err) => {
        console.error('Error loading crack statuses', err);
      }
    });
  }
  HideInspection(inspection: any){
    this._implementService.UpdateInspectionStatusToHide(inspection.ImplementInspectionId, this.ImplementId).subscribe({
      next: (res: boolean) => {
        if(res){
          this.loadEquipmentInspectionDetails();
          this._notify.success("Inspection hide successfully")
        }else{
            this._notify.success("Some Error occured")
        }
      },
      error: (err) => {
        console.error('Error loading crack statuses', err);
      }
    });
  }
  showCrack(){
    this.activeCrackStatusIds = this.crackOptions.filter(o => o.isSelected).map(o => o.Id);
    this.loadAssetDetails();
  }
}
